import {useState, useEffect} from 'react'
import { getCookies, setCookie } from '../shared/Utils'
import { ChevronDown, Phone, Send, BellOff, Bell, Settings } from 'lucide-react';
import Translate from '../shared/Translate';
import PlaceCall from './PlaceCall';
import SendSms from './SendSms';

const Header = (props) => {
  const { providedNumber, openedSection, setOpenedSection, contextPhoneNumber } = props;

  const cookies = getCookies();
  const [callFrom, setCallFrom] = useState(() => {
    if (cookies.callFrom) {
      return cookies.callFrom;
    }

    const lineSettings = props?.callSettings?.lineSettings || {};
    for (const [key, value] of Object.entries(lineSettings)) {
      if (value.isEnabled) {
        setCookie('callFrom', key);
        return key;
      }
    }

    return '';
  });

  const [callAs, setCallAs] = useState('Selected by OptimCall');
  const [callTo, setCallTo] = useState(providedNumber || '');

  useEffect(() => {
    if (providedNumber) {
      setCallTo(providedNumber)
      if (!openedSection) {
        setOpenedSection('call')
      }
    }
    else {
      setCallTo(contextPhoneNumber || '')
    }
  }, [providedNumber, openedSection, setOpenedSection, contextPhoneNumber]);


  const [recipients, setRecipients] = useState(providedNumber || '');
  useEffect(() => {
    if (providedNumber) {
      setRecipients(providedNumber)
    }
    else {
      setRecipients(contextPhoneNumber || '')
    }
  }, [providedNumber, openedSection, setOpenedSection, contextPhoneNumber]);
  const [message, setMessage] = useState('');
  const [smsGateway, setSmsGateway] = useState(() => {
    let smsGatewaySettings = Object.entries(props.settings?.smsSettings?.smsGatewaySettings || [])
    if (cookies.smsGateway) {
      if (smsGatewaySettings.some(([key, value]) => key === cookies.smsGateway && value.isEnabled)) {
        return cookies.smsGateway
      }
      else {
        setCookie('smsGateway', '')
      }
    }
    return Object.entries(props.settings?.smsSettings?.smsGatewaySettings || []).find(([key, value]) => {
      if (value.isEnabled) {
        setCookie('smsGateway', key)
        return true
      }
      return false
    })?.[0] || ''
  })

  const toggleSection = (section) => {
    if (props.openedSection === section) {
      props.setProvidedNumber(undefined)
      setOpenedSection(undefined);
    } else {
      setOpenedSection(section);
    }
  };

  return <>
    <div className="app-header">
      <div className="app-header-sections">
        <button
          className={`tab-button ${openedSection === 'call' ? 'active' : ''}`}
          onClick={() => {
            toggleSection('call')
          }}
        >
          <Phone size={18} />
          {Translate.get('main.place.call')}
          <ChevronDown className={`section-icon ${openedSection === 'call' ? 'expanded' : ''}`} size={18} />
        </button>
        {props.isSmsSupported && cookies.smsGateway &&
          <button
            className={`tab-button ${openedSection === 'sms' ? 'active' : ''}`}
            onClick={() => {
              toggleSection('sms')
            }}
          >
            <Send size={18} />
            {Translate.get('main.send.sms')}
            <ChevronDown className={`section-icon ${openedSection === 'sms' ? 'expanded' : ''}`} size={18} />
          </button>
        }
      </div>
      <div className="app-header-icons">
        {props.stateData.get('settings.silentMode') ? (
          <BellOff className="icon" size={24} onClick={() => {
            props.stateData.set('settings.silentMode', false);
            props.container.tell({
              _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$DisableSilentMode',
            })
          }}>
            <title>{Translate.get('main.silent.mode.disable')}</title>
          </BellOff>
        ) : (
          <Bell className="icon" size={24} onClick={() => {
            props.stateData.set('settings.silentMode', true);
            props.container.tell({
              _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$EnableSilentMode',
            })
          }}>
            <title>{Translate.get('main.silent.mode.enable')}</title>
          </Bell>
        )}
        <Settings className="icon" size={24} onClick={() => props.openSettings()}>
          <title>{Translate.get('settings.title')}</title>
        </Settings>
      </div>
    </div>

    {/* Place Call Section */}
    <PlaceCall
      callFrom={callFrom}
      setCallFrom={setCallFrom}
      callAs={callAs}
      setCallAs={setCallAs}
      callTo={callTo}
      setCallTo={setCallTo}
      setProvidedNumber={props.setProvidedNumber}
      expanded={openedSection === 'call'}
      toggleSection={() => toggleSection('call')}
      settings={props.settings}
      credentials={props.credentials}
      container={props.container}
    />

    {/* Send SMS Section */}
    {props.isSmsSupported && cookies.smsGateway && (
      <SendSms
        recipients={recipients}
        setRecipients={setRecipients}
        setProvidedNumber={props.setProvidedNumber}
        message={message}
        setMessage={setMessage}
        smsGateway={smsGateway}
        setSmsGateway={setSmsGateway}
        expanded={openedSection === 'sms'}
        toggleSection={() => toggleSection('sms')}
        settings={props.settings}
        credentials={props.credentials}
      />
    )}
  </>
}

export default Header;